import { Component, DestroyRef, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { BrnSonnerToaster } from '@spartan-ng/brain/sonner';
import { installNoLeadingSpaceGuard } from './shared/utils/no-leading-space.guard';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BrnSonnerToaster],
  template: `
    <router-outlet />
    <brn-sonner-toaster richColors position="top-right" />
  `,
  styleUrl: './app.scss',
})
export class App {
  constructor() {
    // App-wide: block a leading space in every text input/textarea. See
    // no-leading-space.guard.ts for scope/rationale — registered once here
    // rather than per-form, so it covers the whole app automatically.
    const uninstall = installNoLeadingSpaceGuard(inject(DOCUMENT));
    inject(DestroyRef).onDestroy(uninstall);

    // Force-instantiate eagerly so the persisted theme is applied to <html>
    // before the rest of the app renders, rather than waiting for whichever
    // component happens to inject ThemeService first (the header toggle).
    inject(ThemeService);
  }
}
